import { ROUTES } from '@constants/routes';

import Layout from '@containers/layout';
import NoMatch from '@containers/no-match';

import { RouteType } from './types';
import SignIn from '@containers/auth/sign-in';
import CenterWiseResults from '@containers/CenterWiseResults';
import ConstituencyWiseResults from '@containers/ConstituencyWiseResults';
import Dashboard from '@containers/dashboard';
import { CenterWiseReport } from '@containers/CenterwiseReport';

// import ResultList from '@containers/resultList';

const routes: RouteType[] = [
  {
    id: '1',
    path: `${ROUTES.HOME}`,
    element: <Layout />,
    redirection: <SignIn />,
    permissions: {
      auth: ['token'],
    },
    children: [
      {
        id: '1.1',
        index: true,
        element: <Dashboard />,
        redirection: <SignIn />,
        permissions: {
          auth: ['token'],
        },
      },
      {
        id: '1.2',
        path: `${ROUTES.CONSTITUENCY_WISE_RESULT}`,
        children: [
          {
            id: '1.2.1',
            index: true,
            element: <ConstituencyWiseResults />,
            redirection: <NoMatch />,
            permissions: {
              auth: ['token'],
            },
          },
          {
            id: '1.2.2',
            path: `${ROUTES.CONSTITUENCY_WISE_REPORT}`,
            element: <CenterWiseReport />,
            redirection: <NoMatch />,
            permissions: {
              auth: ['token'],
            },
          },
        ],
      },
      {
        id: '1.3',
        path: `${ROUTES.CENTER_WISE_RESULT}`,
        element: <CenterWiseResults />,
        redirection: <SignIn />,
        permissions: {
          auth: ['token'],
        },
      },
    ],
  },
  {
    id: '2',
    path: '*',
    element: <NoMatch />,
  },
];

export { routes };
